import * as React from 'react'
import Footer from '../components/layouts/Footer'
import RecruitingHeader from '../components/sections/Alumni/components/RecruitingHeader'
import CulturalCollectionsDigitalSection from '../components/sections/EUSections/CulturalCollectionsDigital'
import { HIDE_CONTACT_HEADER_KEY, Themes, useTheme } from '../hooks/useTheme'

const CulturalCollectionsDigital = () => {
  const { setTheme } = useTheme()

  React.useEffect(() => {
    setTheme(Themes.LIGHT)
    localStorage.setItem(HIDE_CONTACT_HEADER_KEY, 'true')
  }, [])

  return (
    <>
      <div id='smooth-wrapper'>
        <div id='smooth-content'>
          <div className='podio--light'>
            <CulturalCollectionsDigitalSection />
            <Footer theme='light' isEu />
          </div>
        </div>
      </div>
      <RecruitingHeader customButtonLabel='Contact Us' />
    </>
  )
}

export default CulturalCollectionsDigital
